export const defaultDatabase = [
  {
    label: 'Radical fragmentation',
    rxnCode:
      'eMHBN`yE@!fH@O}R eFHBLG~hP#Qg Qp Qd#!RGtL@Pqwro@ !RGYi| !R_pp]nop',
    ionization: '[M]-/[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 a./ Fig. 21',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'McLafferty rearrangement',
    rxnCode:
      'gGP`@df]jPOiX@!gC``@dfZ@~bl eF@HxP#qrLk qJt qk#!R{AxRsWi|fUu?IsuBs@ !Rs~KONXH@ZqHd !R[w}[WG`',
    ionization: '[M]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 30',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'McLafferty rearrangement',
    rxnCode:
      'dctFbHSBEP|B{IILTdhuTtpPs}Fp!gOp`AdiekjV`H gJPYHlQxGh}j@~bl#I`tu\\JfxY I[jFRp IaEtp#!R@hbH?_vwmpJH@hc}b@K~@H`BbOw~@AvJ`` !R?g~w@k_}bOvw?[\\BG_k\\ !R?g?~@K_}bOt]vgp',
    ionization: '[M]-',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 30',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Radical fragmentation',
    rxnCode:
      'didH@@RYWZZ@BP@u@H!didH@@RYWZYiYh@u@h#I{DJJXY I{DJJXY#!R_cbDdknR?lc~rKnR?ba?REwLp` !R?`BH@k_|?`C~@K_|?`B_TMuzH`',
    ionization: '[M]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Radical fragmentation',
    rxnCode: 'eMHBN`uR!eMHAIXH#Qg Qg#!ROvL@Xqvro@ !R_rq?Dqtz_@',
    ionization: '[M]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMH`eIhOho~hP!fH@O}R eFH`fJGtP#Qv a` Qt#!R_rq?Dqvr_@ !RGYi| !R@FL]ngp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '1',
    description: 'Fig. 1<NL>',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gC`AEJTu@_z`P!fH@O}R eM@fXvB#qrL a` qrH#!R_qL@Dw}lG_J| !RGQi| !R_qL@DqvzO@',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGPAIJUKUPGQEKQoz`P!gJPAEJU[TA@ fH@O}R#qTis qUap qX#!RmpJH@oy?m?vH?Quro@ !RbOvw?_x@mpH]fgp !RGWi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRfhCTB!fH@O}R eMH`fM``#qrL a` qrH#!R_qL@Dw}lGWI| !RGQi| !R_qL@Dqtz_@',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJXA@IRij`O}PH!gChA@Icm@P fH@O}R#qrM` qrM a`#!Rm?w~@Hc}mpH]|op !Rm?w~@Hc}GSk| !RGQi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRYhCTB!fH@O}R eMH`eIxH#qra a` qrH#!R?g~w?Xc}G_K\\ !RG[i| !R@Ox@?avZ_@',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJXA@IRij`O}PH!gChA@Icm@P fH@O}R#qrM` qrM a`#!Rm?w~@Hc}mpH]lop !Rm?w~@Hc}G[k| !RGYi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRYhCTB!fH@O}R eMH`eIxH#qra a` qrH#!R?g~w?Xc}GWK\\ !RG^i| !R@Ox@?avz_@',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJPa@aJSKTAjA@!gC`a@aJR}@P fH@O}R#qjtH qjq a`#!R?`BH@k\\BbOt]bhH !R?`C~@K\\BGSiB !RGYi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGPa@eJSNuPG~hd!gJPaAaJTtlA@ fH@O}R#qrLk qJn` qX#!R?g~H?[_}b@JH?QtJW@ !Rm?vH?_y?mpH]nmp !RGQi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJPAAJT}TA}CG}QH!eM@bXzCUH eF@HhP#qNj` qNh Qd#!RWrL@Hu}lWrL]tkp !RWrL@HqwZo@ !R@BL]~kp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGQA@IRYvj@~ec~hD!gCaA@IRYhCzBOzbP eF@HhP#qisT qis Qd#!R?g~w?Xc}mpJw?Qtrw@ !R?g~w?Xc}G[k\\ !R@AL]fkp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGXA@IRgVjDE}KG}PH!gChA@IRehPWtD_uL` eF@HhP#qi^T qi^ Qd#!R_qL@Dw}l_qM?[AuR_@ !R_qL@Dw}lG[i| !R@AL]fkp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'did@BBeJU]JiZj`CzAc~hi@!gOpACJTjfruPG~ht eF@HhP#IJlYHxY qMsTx IdP#!R?`BH?X`Bb@JH?Xc}b@JH?QwJ?@ !R?g~w@k_}m?vw@k\\BG[h| !R@AL]Vkp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eM``eIhO}PqFp!fH@O}R eF``fJGtX#Q[ Qp QX#!R@Fp@DqtJ_@ !RG[i| !R_vp]fgp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMB`HIchO}P`!fH@O}R eFB`HIba}D@#Q[ Qp QX#!R_qL@Dqwr_@ !RGSi| !R_vp]fgp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.4.',
    description: 'Fig 7.9',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMB`HIRZCzHjD!fH@O}R eFB`HIba}D@#Q[ Qp QX#!R@Fp@Xqwr_@ !RGYi| !R_rp]ngp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 7.10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMH`eIXO}P`!fH@O}R eFH`fND#Q[ Qp QX#!R@Fp@DquJ_@ !RGSi| !R_vp]Fgp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJQA@IRUZ`OdHL_u@`!eMHbeIhOhc~iP eF@HhP#qir` qip Qd#!R@Fp@XpAl@FL]bgp !R_rq?DqwZ?@ !R@FL]Akp',
    ionization: '[M]+*',
    reaction: 'CMF',
    doi: '',
    section: '7.4.2.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'α-cleavage (cyclic)',
    rxnCode:
      'gFpAAJTj[UTAjQ@!gC`AEJUm@_zfP eF@HhP#qi^b qNk Qd#!R?g~H@hc}bOvH@awrO@ !R@AM?Dw}lGSj| !R@AL]Fkp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '2',
    description: 'Fig. 2',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'eMH`fN`uB!fHT`P eFHBLG~hP#Q[ Qp QX#!R_qL@Dqur_@ !RG[i| !R_vp]fgp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode: 'eF@bXp_za@!fHT`P fH@O}R#Qd QP a`#!R@AL]Rgp !RG]i| !RG^i|',
    ionization: '[M]+*',
    reaction: 'CMF',
    doi: '',
    section: '7.4.1.1.',
    description: 'Fig. 7.6',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'gCaA@IRfhCTB!gBaA@IcLAjY@#qVa qVa#!R@Fq?[@@SGTi| !RDw|S@IW~GYi|',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode: 'eFB`HIcA}D_uB!fH`PA}QT` fHT`P#QX QP a`#!R_vp]Bgp !RGSi| !RG^i|',
    ionization: '[M]+*',
    reaction: 'CMF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 7.10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'gJQA@IRUZ`OdHL_u@`!eMHAIdOh` eF@bXp_zi@#qbqh Qg qi#!R@Fp@DpAl@AL]rgp !R[g|vzqwzW@ !R[g|]Vcp',
    ionization: '[M]+*',
    reaction: 'CMF',
    doi: '',
    section: '7.4.2.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF@Hp_|Ru@!fHT`P fH@O}R#Qd a` QP#!R@BL]bkp !RGYi| !RG]i|',
    ionization: '[M]+*',
    reaction: '',
    doi: '',
    section: '7.4.1.1.',
    description: 'Fig. 7.6',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Remote Hydrogen Rearrangment',
    rxnCode:
      'gJQA@IRUZ`OhXjA@!gJQA@IRUZ`OhHjE@#qir` qir`#!R@Fp@DpAl@AL]Rgp !R@Fp@DpAl@AL]~gp',
    ionization: '[M]+*',
    reaction: 'CRF',
    doi: '',
    section: '4',
    description: 'Fig. 4',
    kind: 'rearrangement',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAGJUKutkPD!gOpAMJUNusMHD#qkOfP qi{tP#!Rm?w~@Hc}mpJw@ox@GWHB !R?`BH?[_}mpJw@k_}G]k|',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAMJUNusMHD!gOpAGJUKutkPD#qkyfP qkOfP#!Rb@Jw@oy?bOvH?_y?G_H| !Rb@K~_{\\BbOvH?_y?GXY|',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAMJUNusMHD!gOpAMJUKua@@D#qi{tP qkOfP#!R?`BH?[_}mpJw@k_}GWK| !Rm?w~@Hc}mpJw@ox@G]k|',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFpAAJTj[UTA@!eF@bXhP eF@HhP eF@HhP#q\\jN q] qN Qd#!RbOvw?_y??g~w?QtrW@ !R@AL]zgp !R@AL]Nkp !R@AL]~kp',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNxaLJIRU[jXCzZ@!eMH`eIxH eF`BJGtP eFHBND#q{iV` Qv qM q{#!Rm?vw?[\\|m?v~_{\\|GXJ\\ !R@Kx@oauZ_@ !R@BL]^gp !R_tp]Agp',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ@!gC`HAxQz`H eM@fXvB eF@HhP#IaLJfxY qan IF^ qS#!R@AMl@G}lDw|@[@@S@Fp@Dqvr_@ !Rm?w~@Hc}GX[| !R_qL@DqvZO@ !R@AL]^kp',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGYALMJT}TpGRdX!gJY@DDefXB fHT`P#qnZa qnTH qX#!Rm?vH?[\\Bm?w~@AwR_@ !RmpJw?[\\B?g|]Fkp !RGWi|',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'dazHBLCIRfVjY`CiBfoQT@!gGYADEJSLtpD eF@HhP#IqBZJG` IqF`^ qM#!RbOvw?X`B?g~w@hc}?`@]|cp !R?g~w?Xc}mpK~_quZg@ !R@AL]~kp',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'gFqAAYRe|Zj`OiH@!gGQA@IRezY@~``#qbqk qbqk#!R_O@T~pAYDEKp@quJ_@ !R@Fq?[@@S_qM?[AwZ_@',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4 ',
    description: 'Fig 23 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'daxHB@zTeVVjh@~ah@!gGQA@IRUVi@~`` eF@HhP#IaLJnXP qbqk IxP#!RdArPwY@\\dMvPGMy?dMt]Bkp !R@@L@[@@C@Fp@@quz_@ !R@@L]akp',
    ionization: '[M]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4 ',
    description: 'Fig 23 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'dcN@B@J\\bRbRaWCUUUL@_ITC@!gFpAEJTjZuRA@ eM`AIhH eM@HvB#IO^adkBFU qb^i IO^ IeQ#!Rm?u~_?C}|Gq~_?A}|Gu~_?A||Gwp_Atr{@ !R_g~w_K_}mwvw_AvZo@ !R@Fp@XqtF_@ !ROvL@XquFo@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Remote hydrogen rearrangement',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ}DP!gGPIAxBTjfjPH eM@HvB#IZnFRqH IZagb Q^#!R@AMl@G}lDw|@[@@S@Fp@Dqwr_@ !R@FpS@G|S[G|@Dqtz_@ !R_qL@DqtFo@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'dclDB@{iRYeevz]ZA`b@CzN`!gGPa@QJRmsPbX gFp@DiTt@@B#IwbFleVPx IwaeS qb^i#!RbMvH?Cx_bMt~@Hc]Oa~H?Hc|Oa|~@Aurw@ !RbCvHOXc|O`BHOQtz_@ !ROg~wWK_}mwvwWAwzO@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'fdeA`D@\\brTfYY_m]gIZ|EhJB@@h@@~aF@!didHB@BTfUvfZVV@OhB@ didD@@iIYgxUie`B#iup`jXdibCPcXKoI iSxKhvMHP IwbkEYH#!RbOrHW]x@bOs^[xc|w`BHWXa]w`C^[xc|ipK^@Mx@i?s^@AuRx` !Ri?rgW]x@i?rg?Mx@i?rg?Aujp` !RmsvwO]y?mqrPw[_]msvwGAwzG@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'dmLDB@{irJJIQEneV`hB@B!eF@HhP didDB@hIRVY~G``@@`#IwlDdeZa` IFP IwlIEjF#!Rg`BH?H_|g`BHGYx@a?rH?Hc|bAt]\\bH !R_uP]Fop !RmuvwWYy?mrr`g[^]muvwKAtzg@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGY@DDf]j`Odkl@!gCi@DDff@~`l eF@HhP#qrLk qrL qk#!R?g~H?[_}b@JH?QvJw@ !RmpK~@K_}GUjB !R@AL]~kp',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Sigmatropic rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvB#Q^ Q[#!R@AM?DqvJO@ !R_qL@DqwZo@',
    ionization: '[M]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium rearragement',
    rxnCode:
      'gOpAMJUKua@@D!gOpAGJTju`@@D#qgVMX qYoTp#!Rg`BGgXb]a?rG?H^]GPhB !RN@swnix@C[AkCDJpGSkB',
    ionization: '[M]+',
    reaction: 'Rearrangement',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#IaLkit I{MbTh#!Rh@VUDFcl?H`N@HCfGXiB !R[X~@abJwFEL@F[y_GSi\\',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#q]yfP qgSuH#!R[X?@qaJONGO@v_y?GWK\\ !RQps~_}?YQwMmc}?FG[i|',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qrLoX qMsW`#!RN@s_qox@[[AGCAJpGWKB !R[[C@vQJpN@s@qox@G_iB',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qMsW` q{eQp#!R[[C@vQJpN@s@qox@GPkB !Rw}dx\\vvO?g|Rct]sGP[\\',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#q{eQp qTwKh#!Rw}dx\\vvO?g|Rct]sG]K\\ !R?`AG\\t\\Lw|[_vVvpGSiB',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qTwKh qqUcx#!R?`AG\\t\\Lw|[_vVvpG]JB !Rw|XxCFvp?`@RlD\\LG[kB',
    ionization: '[M]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMB@HchOh_Hh!fH@O}R eFB`HIcA}CuB#Qg Qp Qd#!RK?t@?Qwr_@ !RGYi| !R_sP]nop',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eM`BN`~b|b`!fH@O}R eF``fLGtWTH#Qg Qp Qd#!RSwt@_Qwr_@ !RGYi| !R_uP]nop',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMHBN`~a|b`!fH@O}R eFH`fLGtOTH#Qg Qp Qd#!RSwt@_Qwr_@ !RGYi| !R_uP]nop',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HIcA}EuB#Qd Qd#!R@DL]Rgp !R@DL]vgp',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGtWdT!eF``fLGtWTH#Qd Qd#!R@BL]Rgp !R@BL]vgp',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`fLGtWTH#Qd Qd#!R@BL]Rgp !R@BL]vgp',
    ionization: '[M]*+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'gC`a@erSM@_SP!fHW@P eMDARUB#qbq qH Qg#!Rb@K~@Hc}GPjB !RGWi| !R_?y??avZ_@',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'dedLB@RTyImUVjj`CzI`!gNq@`N_IJkUTA@ eMDARUB#IfESBinD IGfhlP IfE#!R?g~H?[_}mpJw?[\\Bm?vw@k_}GUs\\ !R_vq?Dw}l_qM?[G|SGQi| !R_?y??avF_@',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daDHB@KdimVz`@@B!gFpAKrTjZ@@A@ eFHBJD#IzaIla@ qrLk IxP#!Rm?vH?[\\B?g~w?[_}?g|]tep !Rb@Jw@ox@?`Bw@auZp` !R_vp]^gp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'gJPa@SrRkTA@!eMH`yIdH eFHBJD#qJuX qJp q]#!R_g?p?_A||Ot]Bmp !R_g?p?QuZw@ !R_rp]^gp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 26 ',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daxDB@HnrJJHmSHA@!eMHAITH eM@ghvB eFHBND#IxjqaR@ IZa Q[ qy#!R?`BH@k\\B?`BH?[_}mpH]xlH !R_?y??awz_@ !R_qL@DqtzO@ !R_vp]Zgp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daDDB@HnRYg[fij@H!gFqAAnRYSVj`H eFHBND#IDjsfR@ IDlYH q}#!RmpJw__x@?g~w@k\\B?`@]dop !R]?pq@B?MOrXkAAtz`` !R_vp]Fgp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'γ-elimination ',
    rxnCode:
      'gNqa@f~RY]jXPl!gJP`@TeUdB eFHBLD#qiZ|p qiTp q_#!R?`BH@k\\BbOvw?_y?GUJB !R_qM?Dw}l_qL]Fcp !R@AL]Agp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'ζ-elimination',
    rxnCode:
      'dedDB@f^RYU^ejXLRrz~`H@!fH@Oj@ diDDB@D^RYWVefALfh#!R?g~w?Xc}mpK~_{_}bOvw@k_}G\\H\\ !RGTY| !R?g~H?[_}b@Jw@hc}b@JH?Quzw@#',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 d.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: '1,3-elimination',
    rxnCode:
      'gJQ@@dsU@_HPX@!eMHAIXH eF@HhP#qJth qJ` qu#!R_`BH?M_|bGt]BhH !R_rq?DquZ_@ !R@FL]~kp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP@Divj`OdHL@!eM@HvB eM@HvB#qVak qiX Q^#!R@Fq?[@@S@Fp@DqtJ?@ !R_qL@DqwZo@ !R@AM?Dqwzo@',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'CO Elimination',
    rxnCode:
      'gGQa@bnR[fj@~a`!gJPa@erS[RA@ fI@Gu`#qrLk qrLX qh#!RbOw~_x`B?`BH?QvJo@ !RmpK~@K_}mpH]zhH !RGWi|',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '2',
    description: 'Fig. 3',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'CO elimination',
    rxnCode:
      'gOp`@tfUkZj`MYd@!gKQ@@eKcUPD eFHBND#q~JlX q\\jH q~#!RupKW_Wx@upKW@gx@GUIB !RHJUSYwy?SF\\]Vmp !R_rp]^gp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.8',
    description: 'Fig. 19',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dctJB@SaT^RYyWfjjf@H!gC`a@erSM@P daDL@@Sdf^Vyjj`B#IMTwBFi[h q{l IMTwBFP#!RmpJw?_x@mpJw?_x@mpJH?K_}?g~w@aw|@` !RmpK~@K_}GYjB !R?`BH@k\\BbOt`^gi_^e|]ahH',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dctFbHSBEP|ByJk_mZjjh@~`X@!eFHBLGtP deTJbHSBdOB^rRSIHlKUUT@P#ISBbfOae] IWP ISJJIX~D#!R@k^w?Hc|?[^w?Xc}m?s~@K_}m?rw?QuB?@ !R_vp]agp !Rm?w~_xc|mpJH?Xc}m?vH?Ha}G[h|',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dcLFbHSBEP|ByJk_Vifjjf`B!gC`a@erSM@P dadB`HSBCpRjuijyjjh@`#IIjshPYWS IuYL IIjshPP#!Rs|uTaOrwYrsPs\\Bfb@JH?X`B?`BH?QtJ@` !RmpK~@K_}GUjB !RbOu?x_h`Ou}udE_\\U}p]~gp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Eliminations assisted by β-hydrogen removal',
    rxnCode:
      'dctJbHSNdOCNrRSEISMUTt@[PTXIF@PvB@!gNpYHlqxOdj}Zj@~f` gCa@@djpD#IeQtNZlIH IeQwfh qNT#!R@hbw@gvwbOvw?[\\Bm?vw@ox@m?vw@at|?@ !R?`Bw?Xc}mpJw?[\\BGP[| !R@Ox@?`JHG]k|',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2.4',
    description: 'Fig. 29',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``zN`~ap#Qg Qg#!RgzL@XqvJ_@ !Rw?P@[AwZ?@',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HNcA}C`#Qd Qd#!R@Fp]rgp !R_`@]vop',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFJH|Hp_U_~UP!eFJh|Khp_Tx#QX QX#!R_wP]Bop !R_wP]Vop',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`zLGtN#Qd Qd#!R@Fp]Rgp !R_`@]vop',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'gCa@@eMPD!eFHBLGtP eF@HhP#qTq Q\\ qa#!R@NL?xpAlG_K\\ !R@FL]Ngp !R@FL]Akp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFq@@eJftu@P!gCa@@dkHD eF@HhP#qi^b qir qc#!R?g~w@k_}m?vw@auRO@ !R@AL@[@@SG]i| !R@AL]^kp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 d. & Fig 10 e.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@@dkT`_PQ~zSOp!eM@HvB eFHBJD#qiTp Qg qi#!R_vq?Dw}l_qL]top !R_qL@DqwZo@ !R_vp]^gp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`@df]j`OiX@!gC``@dfZ@~b` eF@HhP#qYnb qYn Qd#!R?g~H?[_}b@JH?QvJw@ !RmpK~@K_}GUjB !R@AL]~kp',
    ionization: '[M-H]-',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Aromatic elimination',
    rxnCode:
      'ded@@DiUUeiZ@hTZfh!gFp@DiTt@@B gC`@DiZDC@#IpdjFGiT qcUq IGiT#!RbGvw_X`B?g?~@K]}b@K~_?x@G_J| !R?g~w@k_}m?vw@avzO@ !Rb@K~_xc}G]j|',
    ionization: '[M+Na]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.6',
    description: 'Fig. 16',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`@TeYjPOhX@!eMHAIdOh` eMHAITH#qirc qip qbX#!RmpJw?[\\Bm?w~@Awb@` !R_vq?Dquz_@ !R@Ox@?auZ_@',
    ionization: '[M+Na]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gNpiIahRTeVfj@~ec|x@!gC`iIahRTef@~fc|x@ eM@HvB#qbqkx qar qkx#!R@G{Ds\\RRqLu~y|RRGWK\\ !R@G{Ds\\RRG[i| !R@FL?XqvFo@',
    ionization: '[M+Na]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom with cyclisation',
    rxnCode:
      'gNuADpyRUUjhB!gFyALAJTjZuTA@ fJ@D#q|VMX q|jN qX#!R_vq?Dw}l_qM?[G|SGYI| !R?g~w@k_}m?vw@auZw@ !RG_i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFp@DiTvjhB!eF@HhP eF@HhP eF@HhP#qcUq Qd qk qN#!R_`CW_]\\BupKW_QwR@` !R@FL]fkp !R@FL]nkp !R@FL]~kp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'gGYADEJSLuPGtT_nlK|!gChA@Icu@_PP eFHBND#qtSi qQ] Qx#!RbGvH@gx?bGu~@AtJo@ !Ruwu~@Ha}GUk| !R_rp]^gp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7.1.3',
    description: 'Fig. 22 c. ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJXA@IRUjPH!eM@fXvB eF`BLGtP#qlVH qrH ql#!R@FL@[@CC@Fp]bgp !RGtL@PqwZO@ !R@DL]~gp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJPI@DBTeZdB!eM@fXvB eFB@HcA}D@#qbqh qNh Qd#!R@BL@[@BC@Fp]Bgp !R[pL@@qwZO@ !R@@L]~gp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJQA@IRUjPH!eM@fXvB eFH`fLGtP#qbqh qNh Qd#!R@BL@[@BC@Fp]Bgp !R[pL@@qwZO@ !R@@L]~gp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Double cleavage',
    rxnCode: 'gChA@Icu@_PP!gBhA@IcLA}A@#qTq qTq#!Rm?w~@Hc}GPk| !RDp@S_yW~GYi|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJPaAaJTkTHGyZC@!eMDaIRVCyHX@ eF@HhP#qbqh qbH qu#!RupJH@gx@bGt]\\hH !R_rq?DquZ_@ !R@FL]Akp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@IRmhCzB@!eF``fJGtX eF@HhP#qTq QX qq#!R_vp@[@@SGXi| !R_vp]Ngp !R@AL]Fkp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJXA@IRmZ`OdHL@!eM`bfN`~b@ eF@HhP#qTqh Q^ qi#!R_qL@DpAl@AL]Rkp !R_qL@DquZo@ !R@AL]~kp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNpaAQJSOMU@_HQX@!gCa@@duPGtD@ eMH`eIXOh`#qNWeX qNW qlX#!Rb@JH_Wx@b@I~@Ha}GWJB !Ru?sW_Wx@GYjB !R_rq?Dqwz_@',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Halide elimination',
    rxnCode: 'eFBcDIcA}D@!fHfHA}P fHT`P#QX QP a`#!R_rp]\\gp !RGUi| !RG[i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Halide elimination',
    rxnCode: 'eFBbHIcA}D@!fHdPA}P fHT`P#Qd a` QP#!R_pp]\\op !RGUi| !RG[i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Hydrogen elimination',
    rxnCode:
      'gFpACJTj[KTA}C`!gFpAAJTjZ@@A@#qbqk qn\\J#!R?g~w@k_}m?vw@aurO@ !RbOvw?_y??g~w?QwZW@',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gBQA@IRoYj@~f`!eFH`fJGtP eF@HhP#qqT qq Qd#!R_vp@[@@SGTk| !R_vp]^gp !R@AL]Vkp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eMDaYRVCzX@!fI@D eFH`fND#Qg Qp Qd#!RG`BH?AtJ`` !RGYk| !R_qP]nop',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode:
      'eMJdBBTfP~b@!fH`PA@ eFH`fND#Qg a` Qt#!Rm{u~_qurw@ !RGUi| !R_yP]nop',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eMhdYRVCz\\@!fJ@D eFH`fND#Qg Qp Qd#!RG`BH?AtJ`` !RGUi| !R_qP]nop',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFH`fLGtX!fI@Gu` fHT`P#Qd a` QP#!R@AL]|gp !RGUi| !RG[i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFB`HIcA}F@!fH`PA}X fHT`P#Qd a` QP#!R@BL]Bgp !RGYi| !RGSi|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eF``fLGt\\!fJ@Gup fHT`P#Qd a` QP#!R@BL]Bgp !RGYi| !RGSi|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFBcpIcA}G@!fHg`A}\\ fHT`P#Qd a` QP#!R@DL]Bgp !RGYi| !RGSi|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eM``fN`~c@!fHT`P eF`BLGtX#Qg QP Ql#!R@DL?xqwr_@ !RG[i| !R?`@]Vgp',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'dayHBDxDeIYujj@OdRJ`!gCi@DDeZ@~b` gChA@IRVdCzB@#IyjH\\R@ IyjD qbq#!RmpJw?[\\B?g~w?[\\Bm?t]Pkp !R_vq?Dw}lGWi| !R@AL@[@@SG]i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4',
    description: 'Fig 23 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@Hba}CyE@!eFB`HIba}E`#Qd Qd#!R_sP]bop !R_sP]vop',
    ionization: '[M+H]+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BJGtOdT!eF``fJGtV#Qd Qd#!R_uP]bop !R_uP]vop',
    ionization: '[M+H]+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBJGtOdT!eFH`fJGtV#Qd Qd#!R_uP]bop !R_uP]vop',
    ionization: '[M+H]+',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBBHcArJ!eFBbHIcA}E`#QX QX#!R@Al]bgp !R@Ol]vkp',
    ionization: '[M+H]+',
    reaction: '',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBCDcArJ!eFBcDIcA}E`#QX QX#!R_tp]Bgp !R_tp]vgp',
    ionization: '[M+H]+',
    reaction: '',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eMB@HchOh_Hh!eMB`HIchOhl#Qg Qg#!R@FN?DqtJo@ !R@FM?Dqtz_@',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``fN`~cP#Qg Qg#!R@BL?xqtJO@ !R@BN?Dqtz_@',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`fLGtZ#Qd Qd#!R@BL]Bcp !R@BL]Ngp',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Oxonium Resonance',
    rxnCode: 'eFH`fJGtP!eFHbfLGtP#QX QX#!R@Fp]rgp !R@FL]Nkp',
    ionization: '[M+H]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode: 'eMHAIhOda`!fI@Gu` eF@HhP#Qg a` Qt#!R@FL@[AtJ_@ !RGUi| !R_qL]^kp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 a. & b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Resonance',
    rxnCode: 'eFB`HIba@!eFB`HicA@#Qd Qd#!R@Fp]bgp !R@Fp]Nop',
    ionization: '[M+H]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Resonance',
    rxnCode: 'eF``fJD!eF`bfLD#Qd Qd#!R@Fp]bgp !R@Fp]Nop',
    ionization: '[M+H]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gOu@Dpdrm[TtA@!gJY@BDeUdB eF`BJD#IgBRhX IgDa` qM#!RepJWO[x@e?rW@kx@G^IB !R@Fp@[@Bc@Fp]N`H !R_qL]~gp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFx@@eJfuS@P!gC`@Die@` eF`BJD#q]aV qqU q\\#!Rog~pOK@}lCvpOAwrO@ !Re{v~@I\\BGQk| !R_qL]ngp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFp@DiTujhB!gC`@Die@` eF@HhP#q]aV q]a Q\\#!Rm{wpoWy?_g?poQvr{@ !R@Fp?[@AcGUk| !R@Fp]~kp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'daDD@@QIe^fZfh@`!gGQ@@djlrHf eFHBJD#ItYyRhp It^Jc IeP#!RbOvH?Oy?bOvH__y?bOt]|ep !RbOw~_xc}b@JH?QtFW@ !R@AL]fgp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@@eKS@_Pq~LT!eMHAIXH eF@HhP#qTuH qTh qq#!R@Fp?[@AcOvL]lgp !R_rq?DqvZ_@ !R@FL]~kp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daDLB@SdeIeVfZjh@~QHz@!gCaAAiRUhB gC``@dfi@~PaP#Izb[HPP IFDp q}K#!R?g~w_Xa}?g?~_xa}bGt]tnp !R_vq?Dw}lG^k| !R?g~H?[_}GP[\\',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daxDB@PIRYUZf``gZF|`QtQahXO}a`!gJQ@@djl`P eFH`fLGtX#qnQcG qnKx QX#!R?g~w?Xc}mpJH@k_}?`@]dep !R@AL@DpAl@AL]^cp !R@AL]agp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene (Claisen rearrangement)',
    rxnCode:
      'daxH@@Revif`B!daxH@@RUiZjPB#IrBRfxP IrDZax`#!RmpJH@k_}bOvH@hc}?`@]|`H !R@AL@[@@S@Fql_qM?@AL]~cp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gJQ@@dju@_Pp!eMHAIhOh` eF@HhP#qir` qip Qd#!RpQ]?oQNx`cQCGMP !R{d]?{WORi@ !Rpw~C^hp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Tropylium resonance ',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qgSuH qrLoX#!RQps~_}?YQwMmc}?FGUH| !RN@s_qox@[[AGCAJpGXXb',
    ionization: '[M+H]+',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eMHAIhOlba`!fI@Gu` eF@HhP#Qv Qp Qd#!R_vq?Dqur?@ !RG[i| !R@AL]Vkp',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eMHAIhOda`!eNHAAP~c@#Qv Qy#!R_vq?DqvJ_@ !R~nzi_qtz_@',
    ionization: '[M+H]+',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode:
      'gCiALAJRu@_HYl@!fI@Gu` eO``fNZ`~c@#qNT qH Qg#!R@AL@[@@SGXj| !RG_i| !R?g~w?QwZo@',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode:
      'gGYAJAJRkUPGrFW@!gKXA@IReqjhCzC@ fI@Gu`#qbqk q]Qp a`#!R@AL@[@@S@Fp@DquJo@ !R?g|_Fa}eTv\\]vcp !RGPY|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode:
      'gJYABAJRmTA|aap!gBXA@IReZj@~`p fI@Gu`#qNTh qlr qH#!R@Fp@DpAl@AL]rgp !R@O{~@Ox@G]k| !RG_i|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode:
      'gNyAFAJRjuU@_HX|@!gFxA@IReSZj`OhL@ fI@Gu`#q}NTX q\\jN qx#!R_vq?Dw}l_qM?[G|SGVI| !RbOvw?_y??g~w?QtzW@ !RGPY|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode:
      'dazHBN@IRUUjj`Cy@sl@!gOxA@IReVnjj@~`p fI@Gu`#IEjKDc` q|ZnH ID#!R@AL@[@@S@Fp@DpAl@AL]rkp !R?g}GCD]sw}g_qfvOGSh| !RGXY|',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: 'water elimination',
    rxnCode: 'eMH`eIXOda`!eNHbeAP~c@#Qy Qy#!R_vq?DqvJ_@ !R~nzi_qtz?@',
    ionization: '[M+H]+',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    'Column 16': '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP`@TfZj`OdHL@!eMHAIXH eMHAIXH#qnSa qnX qbH#!Rog~po[^}og~pOAvrg@ !R@Fp@Hqtz_@ !R@Fp@HqtF_@',
    ionization: 'Unknown',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 c.',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    'Column 16': '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'diDD@@IIf]jjh@~HHJFch@!gGP`Ademj`Oih@ eM@HvB#IXjsaRX IXjxY Q^#!R?g~H?[_}?g~H@k\\BbOvw?QtrG@ !Rb@JH?_y?b@JH?QvzO@ !R@AM?DqtFo@',
    ionization: 'Unknown',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 d.',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``zLGtV#Qd Qd#!R_qL]Rgp !R_}P]vop',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'fH`PA}[eP!fHpPxCzl#a` a`#!RG\\i| !RGWk|',
    ionization: '[M-H]-',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eMHBN`~a|b`!eMH`fN`~bp#Qg Qg#!R@DL?xquJ_@ !R@DL?xqwZ_@',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HIcA}F`#Qd Qd#!R@FL]Bcp !R@FL]Ngp',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``fLFD@#Qd Qd#!R@AL]Rgp !R@AL]vop',
    ionization: '[M+H]+',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    'Column 16': '',
  },
];
